import Link from 'next/link'
import { IconButton } from '@stone-payments/jade'

export function FaqLink() {
  return (
    <Link href="https://ajuda.stone.com.br/" passHref legacyBehavior>
      <a target="_blank">
        <IconButton title="Ir para a FAQ" icon="circle-help" size="medium" variant="neutral-subtle" />
      </a>
    </Link>
  )
}
